<template>
  <div class="default-container">
    <h1>欢迎登录格隆汇活动系统~{{user}}</h1>
    <p>现在是北京时间：{{time}} </p>
  </div>
</template>

<script>
  import moment from "moment"
  export default {
    data() {
      return {

      }
    },
    methods: {

    },
    props: ['user', "role"],
    computed: {
      time() {
        return moment().format("YYYY-MM-DD hh:mm:ss")
      }
    }
  }

</script>

<style scoped>
  .default-container {
    padding: 15px;
  }

  .default-container h1,
  .default-container p {
    padding: 10px 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/backend/default.vue